import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/finajan`;

const client = {
  // Piyasa özeti
  getMarketOverview: (marketType = 'BIST') => axios.get(`${API}/market-overview?market_type=${marketType}`, { withCredentials: true }),
  
  // Hisse listesi
  getUniverse: () => axios.get(`${API}/universe`, { withCredentials: true }),
  
  // OHLCV verisi (TradingView grafiği)
  getOHLCV: (symbol, period = '6mo') => axios.get(`${API}/ohlcv/${symbol}?period=${period}`, { withCredentials: true }),
  
  // Teknik sinyaller
  getSignals: (symbol) => axios.get(`${API}/signals/${symbol}`, { withCredentials: true }),
  
  // Tam analiz (backtest + AI rapor)
  getFullAnalysis: (symbol) => axios.get(`${API}/analyze/${symbol}`, { withCredentials: true }),
  
  // Özel analiz (kullanıcı parametreleriyle)
  customAnalyze: (symbol, params) => axios.post(`${API}/custom-analyze/${symbol}`, params, { withCredentials: true }),
  
  // Backtest
  runBacktest: (symbol) => axios.get(`${API}/backtest/${symbol}`, { withCredentials: true }),
  
  // Gösterge ağırlıkları
  getWeights: (symbol) => axios.get(`${API}/weights/${symbol}`, { withCredentials: true }),
  
  // Temel analiz
  getFundamentals: (symbol) => axios.get(`${API}/fundamentals/${symbol}`, { withCredentials: true }),
  
  // Ajan performansı
  getAgentPerformance: () => axios.get(`${API}/agent-performance`, { withCredentials: true }),
  
  // Tahmin geçmişi
  getPredictionHistory: (symbol) => axios.get(`${API}/prediction-history/${symbol}`, { withCredentials: true }),
  
  // Tahmin değerlendirmesi tetikle
  evaluatePredictions: () => axios.post(`${API}/evaluate-predictions`, {}, { withCredentials: true }),

  // Portföy
  getPortfolio: (status = 'open') => axios.get(`${API}/portfolio?status=${status}`, { withCredentials: true }),
  addPosition: (data) => axios.post(`${API}/portfolio`, data, { withCredentials: true }),
  updatePosition: (id, data) => axios.put(`${API}/portfolio/${id}`, data, { withCredentials: true }),
  closePosition: (id, exitPrice) => axios.post(`${API}/portfolio/${id}/close`, { exit_price: exitPrice }, { withCredentials: true }),
  deletePosition: (id) => axios.delete(`${API}/portfolio/${id}`, { withCredentials: true }),

  // Alarmlar
  addAlert: (data) => axios.post(`${API}/alerts`, data, { withCredentials: true }),
  getAlerts: () => axios.get(`${API}/alerts`, { withCredentials: true }),
  deleteAlert: (id) => axios.delete(`${API}/alerts/${id}`, { withCredentials: true }),

  // Bildirimler
  getNotifications: () => axios.get(`${API}/notifications`, { withCredentials: true }),

  // Sentiment
  getMarketSentiment: () => axios.get(`${API}/market-sentiment`, { withCredentials: true }),
  getSymbolSentiment: (symbol) => axios.get(`${API}/sentiment/${symbol}`, { withCredentials: true }),

  // Watchlist / Gözlem
  getWatchlist: () => axios.get(`${API}/watchlist`, { withCredentials: true }),
  addToWatchlist: (data) => axios.post(`${API}/watchlist`, data, { withCredentials: true }),
  removeFromWatchlist: (symbol) => axios.delete(`${API}/watchlist/${encodeURIComponent(symbol)}`, { withCredentials: true }),
  getScorecard: (symbol) => axios.get(`${API}/scorecard/${symbol}`, { withCredentials: true }),
  getAccuracyOverlay: (symbol) => axios.get(`${API}/accuracy-overlay/${symbol}`, { withCredentials: true }),
  getWatchlistScorecard: () => axios.get(`${API}/watchlist-scorecard`, { withCredentials: true }),
  getRecommendation: (symbol) => axios.get(`${API}/recommendation/${symbol}`, { withCredentials: true }),

  // PDF Rapor
  downloadReport: (symbol) => axios.get(`${API}/report/${symbol}`, { withCredentials: true, responseType: 'blob' }),
  downloadReportFromAnalysis: (analysis) => axios.post(`${API}/report-from-analysis`, analysis, { withCredentials: true, responseType: 'blob' }),

  // Strateji Lab
  getStrategyRules: () => axios.get(`${API}/strategy-rules`, { withCredentials: true }),
  testStrategy: (symbol, rules) => axios.post(`${API}/strategy-test/${symbol}`, rules, { withCredentials: true }),

  // Konsey
  runCouncil: (symbol, params) => axios.post(`${API}/council/${symbol}`, params || {}, { withCredentials: true }),

  // Risk & Execution
  getRiskSettings: () => axios.get(`${API}/risk-settings`, { withCredentials: true }),
  updateRiskSettings: (data) => axios.post(`${API}/risk-settings`, data, { withCredentials: true }),
  calculateSize: (data) => axios.post(`${API}/calculate-size`, data, { withCredentials: true }),
  executeOrder: (data) => axios.post(`${API}/execute-order`, data, { withCredentials: true }),
  getCircuitBreaker: () => axios.get(`${API}/circuit-breaker`, { withCredentials: true }),
  resetCircuitBreaker: () => axios.post(`${API}/circuit-breaker/reset`, {}, { withCredentials: true }),
  getTradeLog: () => axios.get(`${API}/trade-log`, { withCredentials: true }),
  
  // Analytics
  getEquityCurve: () => axios.get(`${API}/equity-curve`, { withCredentials: true }),
  getAgentWeights: () => axios.get(`${API}/agent-weights`, { withCredentials: true }),
  getSystemHealth: () => axios.get(`${API}/system-health`, { withCredentials: true }),
  getAgentReport: (period = '7d') => axios.get(`${API}/agent-report?period=${period}`, { withCredentials: true }),
  getAgentReportPDF: (period = '30d') => axios.get(`${API}/agent-report-pdf?period=${period}`, { withCredentials: true, responseType: 'blob' }),
  getAllNews: (market = 'ALL', limit = 100) => axios.get(`${API}/all-news?market=${market}&limit=${limit}`, { withCredentials: true }),
};

export default client;
